import { SimpleGame } from "../../app";
import { Selectable } from "../menu/interfaces";
import getDecorators from "inversify-inject-decorators";
import container from "../../ioc/inversify.config";
import TYPES from "../../ioc/types";
import { ThemeManager } from "../design-system/theme-manager";

const { lazyInject } = getDecorators(container);

export class TextContent extends Phaser.GameObjects.Text implements Selectable {
    @lazyInject(TYPES.ThemeManager)
    private themeManager: ThemeManager;

    constructor(x: number, y: number, text: string, scene: Phaser.Scene) {
        const themeManager = container.get<ThemeManager>(TYPES.ThemeManager);

        super(scene, x, y, text, {
            color: themeManager.getColorString("text.primary"),
            align: "left",
            fontSize: themeManager.getFontSize("base"),
            fontFamily: themeManager.getFontFamily(),
            wordWrap: { width: SimpleGame.GAME_OPTIONS.screenWidth },
            stroke: themeManager.getColorString("ui.backgroundDark"),
            strokeThickness: themeManager.getStrokeWidth("normal"),
            resolution: 2,
        });

        // Enable round pixels to prevent rendering artifacts
        this.setOrigin(0, 0);

        // Force texture update after creation to fix initial rendering artifacts
        this.updateText();
    }

    public select() {
        this.setColor(this.themeManager.getColorString("text.selected"));
    }

    public unselect() {
        this.setColor(this.themeManager.getColorString("text.primary"));
    }

    public destroy() {
        // Keep existing destroy logic (commented out)
        // this.active = false;
        // this.visible = false;
    }
}
